import { render, staticRenderFns } from "./QuoteBuilderPartItemTemplate.vue?vue&type=template&id=8c10e7e2"
import script from "./QuoteBuilderPartItemTemplate.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderPartItemTemplate.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderPartItemTemplate.vue?vue&type=style&index=0&id=8c10e7e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports